module.exports = __webpack_public_path__ + "static/media/unicorn_logo.3df8f6e1.svg";